export function nextAnimationFrame(callback?: VoidFunction, wait?: number) {
    return new Promise<void>((resolve) => requestAnimationFrame(() => {
        setTimeout(() => {
            callback?.();
            resolve();
        }, wait ?? 0);
    }));
}
